<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5
        class="modal-title"
        id="CycleModalLabel"
      >Add</h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <form
        class="form-horizontal needs-validation"
        novalidate
        id="formAddCycle"
      >
        <!-- Row -->
        <div class="row">
          <!-- Column -->
          <div class="col-lg-6 col-xlg-6 col-md-6">
            <div class="mb-3">
              <label class="col-md-12">Supplier Code</label>
              <div class="col-md-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="spl_name"
                  readonly
                />
                <input
                  type="hidden"
                  class="form-control"
                  v-model="spl_id"
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Dock</label>
              <div class="col-md-12">
                <select
                  v-model="dk_id"
                  class="form-control-line form-select form-select-fix"
                  style="width: 100%"
                  required
                  placeholder="Choose dock..."
                >
                  <option
                    selected
                    value=""
                  >Choose dock</option>
                  <option
                    v-for="(dk, i) in dockModalList"
                    :key="'dk' + i"
                    :value="dk.dk_id"
                  >
                    {{ dk.dk_code }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Pattern</label>
              <div class="col-md-12">
                <select
                  v-model="cdmp_id"
                  class="form-control-line form-select form-select-fix"
                  style="width: 100%"
                  required
                  placeholder="Choose pattern..."
                >
                  <option
                    selected
                    value=""
                  >Choose pattern</option>
                  <option
                    v-for="(cdp, i) in patternModalList"
                    :key="'cdp' + i"
                    :value="cdp.cdmp_id"
                  >
                    {{ cdp.cdp_name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Effective date</label>
              <div class="col-md-12">
                <a-date-picker
                  v-model="cdc_date"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                  placeholder="Select Date"
                  required
                />
                <!-- <a-date-picker
                  v-model="cdc_date"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                  placeholder="Select Date"
                  :disabled-date="disabledEndDate"
                /> -->
                <div class="invalid-feedback">
                  Please enter Effective date.
                </div>
              </div>
            </div>
          </div>
          <!-- Column -->
          <!-- Column -->
          <div class="col-lg-6 col-xlg-6 col-md-6">
            <div class="mb-3">
              <label class="col-md-12">Plant Code</label>
              <div class="col-md-12">
                <input
                  type="text"
                  v-model="spl_plant_code"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Order Process Category</label>
              <div class="col-md-12">
                <select
                  v-model="opc_id"
                  class="form-control-line form-select form-select-fix"
                  style="width: 100%"
                  required
                >
                  <option
                    selected="selected"
                    value="1"
                  >0 : Auto order</option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-md-12">Truck No.</label>
              <div class="col-md-12">
                <input
                  type="number"
                  v-model="cdc_truck_no"
                  class="form-control"
                  required
                />
                <div class="invalid-feedback">
                  Please enter Truck No.
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="col-md-12">Order Cycle</label>
              <div class="row">
                <div class="col-md-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_cycle_x"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter x.
                  </div>
                </div>
                <div class="col-md-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_cycle_y"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter y.
                  </div>
                </div>
                <div class="col-md-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_cycle_z"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter z.
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="col-md-12">Delivery Cycle</label>
              <div class="row">
                <div class="col-md-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_delivery_x"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter x.
                  </div>
                </div>
                <div class="col-md-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_delivery_y"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter y.
                  </div>
                </div>
                <div class="col-md-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="cdc_delivery_z"
                    required
                  />
                  <div class="invalid-feedback">
                    Please enter z.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
        <!-- Row -->
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary btn-fix"
        data-bs-dismiss="modal"
        id="cycleModalclose"
      ><i class="fa fa-times"></i> Close</button>
      <button
        type="button"
        class="btn btn-info btn-fix"
        @click="checkForm"
        id="submitbtn"
      ><i class="fas fa-save"></i> Save</button>
    </div>
  </div>
</template>

<script>
import api from '../../models/cycle'

export default {
  props: ['modalAddCycle', 'loadNewCycle'],
  data () {
    return {
      opc_id: 1,
      cdmp_id: '',
      spl_id: '',
      dk_id: '',
      cdc_date: null,
      cdc_truck_no: 1,
      cdc_cycle_x: 1,
      cdc_cycle_y: 1,
      cdc_cycle_z: 1,
      cdc_delivery_x: 1,
      cdc_delivery_y: 1,
      cdc_delivery_z: 1,
      spl_code: '',
      spl_name: '',
      spl_plant_code: '',
      patternModalList: [],
      dockModalList: []
    }
  },
  methods: {
    checkForm () {
      if (this.opc_id !== '' && this.cdmp_id !== '' && this.spl_id !== '' && this.dk_id !== '' && this.cdc_date !== null && this.cdc_truck_no !== '' && this.cdc_cycle_x !== '' && this.cdc_cycle_y !== '' && this.cdc_cycle_z !== '' && this.cdc_delivery_x !== '' && this.cdc_delivery_y !== '' && this.cdc_delivery_z !== '') {
        this.insertCycle()
      } else {
        $('#formAddCycle').addClass('was-validated')
      }
    },
    disabledEndDate (endValue) {
      let date = new Date()
      date.setDate(date.getDate() - 1)
      const startValue = date
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    insertCycle () {
      $('.preloader').fadeIn()
      let formData = {
        opc_id: this.opc_id,
        cdmp_id: this.cdmp_id,
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        cdc_date: this.cdc_date === null ? '' : this.dateFormatYMD(this.cdc_date),
        cdc_truck_no: this.cdc_truck_no,
        cdc_cycle_x: this.cdc_cycle_x,
        cdc_cycle_y: this.cdc_cycle_y,
        cdc_cycle_z: this.cdc_cycle_z,
        cdc_delivery_x: this.cdc_delivery_x,
        cdc_delivery_y: this.cdc_delivery_y,
        cdc_delivery_z: this.cdc_delivery_z
      }
      api.addCycle(
        this.$store.state.URLHost,
        formData,
        this.header,
        result => {
          if (result.response === true) {
            this.loadNewCycle()
            this.alert_msg('success', 'Successful', result.message)
            $('.preloader').fadeOut()
            $('#CycleModal').modal('hide')
          } else {
            this.loadNewCycle()
            this.alert_msg('warning', 'Warning', result.message)
            $('.preloader').fadeOut()
            $('#CycleModal').modal('hide')
          }
        },
        error => {
          this.loadNewCycle()
          this.alert_msg('error', 'An error occurred.', error.message)
          $('.preloader').fadeOut()
          $('#CycleModal').modal('hide')
        }
      )
    },
    //  getOrderProcess () {
    //    this.orderProcessModalList = []
    //    api.getOrderProcess(
    //      this.$store.state.URLHost,
    //      this.header,
    //      result => {
    //        if (result.response === true) {
    //          this.orderProcessModalList = result.data
    //        } else {
    //          this.alert_msg('warning', 'An error occurred.', result.message)
    //        }
    //      },
    //      error => {
    //        this.alert_msg('error', 'An error occurred.', error.message)
    //      }
    //    )
    //  },
    getDock () {
      this.dockModalList = []
      api.getDock(
        this.$store.state.URLHost,
        this.modalAddCycle.spl_id,
        this.header,
        result => {
          if (result.response === true) {
            this.dockModalList = result.data
          } else {
            this.alert_msg('warning', '1 An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    listPattern () {
      this.patternModalList = []
      api.listPattern(
        this.$store.state.URLHost,
        this.modalAddCycle.spl_id,
        this.header,
        result => {
          if (result.response === true) {
            this.patternModalList = result.data
          } else {
            this.alert_msg('warning', '2 An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    }
  },
  watch: {
    modalAddCycle: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.spl_id = newValue.spl_id
        this.spl_code = newValue.spl_code
        this.spl_name = newValue.spl_name
        this.spl_plant_code = newValue.spl_plant_code
        $(document).on('show.bs.modal', '.modal', function () {
          var zIndex = 1040 + (10 * $('.modal:visible').length)
          $(this).css('z-index', zIndex)
          setTimeout(function () {
            $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack')
          }, 0)
        })
      }
    }
  },
  created () {
    this.getDock()
    this.listPattern()
  },
  mounted () {
    var myModalEl = document.getElementById('CycleModal')
    myModalEl.addEventListener('shown.bs.modal', event => {
      this.opc_id = 1
      this.cdmp_id = ''
      this.spl_id = this.modalAddCycle.spl_id
      this.dk_id = ''
      this.cdc_date = null
      this.cdc_truck_no = 1
      this.cdc_cycle_x = 1
      this.cdc_cycle_y = 1
      this.cdc_cycle_z = 1
      this.cdc_delivery_x = 1
      this.cdc_delivery_y = 1
      this.cdc_delivery_z = 1
      $('#formAddCycle').removeClass('was-validated')
    })
    $(document).on('show.bs.modal', '.modal', function () {
      var zIndex = 1040 + (10 * $('.modal:visible').length)
      $(this).css('z-index', zIndex)
      setTimeout(function () {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack')
      }, 0)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/cycle_add_modal.vue